module.exports = __webpack_public_path__ + "img/bg.fa64855e.png";